import request from '@/utils/request'
const api = {
  getVideoAdvList: 'video_adv/getVideoAdvList',
  getMyAdvList: 'video_adv/getMyAdvList',
  snapUp: 'video_adv/snapUp',
  payAdv: 'video_adv/payAdv',
  payAdvIncome: 'video_adv/payAdvIncome',
  getVideoAdv: 'video_adv/getVideoAdv',
  getCountry: 'video_adv/getCountry'
}
export default {
  getVideoAdvList(parameter) {
    return request({
      url: api.getVideoAdvList,
      method: 'POST',
      data: parameter
    })
  },
  getCountry(parameter) {
    return request({
      url: api.getCountry,
      method: 'POST',
      data: parameter
    })
  },
  getVideoAdv(parameter) {
    return request({
      url: api.getVideoAdv,
      method: 'POST',
      data: parameter
    })
  },
  getMyAdvList(parameter) {
    return request({
      url: api.getMyAdvList,
      method: 'POST',
      data: parameter
    })
  },
  payAdv(parameter) {
    return request({
      url: api.payAdv,
      method: 'POST',
      data: parameter
    })
  },
  payAdvIncome(parameter) {
    return request({
      url: api.payAdvIncome,
      method: 'POST',
      data: parameter
    })
  },
  snapUp(parameter) {
    return request({
      url: api.snapUp,
      method: 'POST',
      data: parameter
    })
  }
}
